import React from 'react';
import Pages from '../../routes/Pages';

const Content = (props) => {
  return <Pages {...props} />;
};

export default Content;
